import { useState } from "react";
import { categoryTabs, filterGroups } from "@/mocks/gossip";

const tagColor: Record<string, string> = {
  深度解析: "bg-primary-500/10 text-primary-700",
  前瞻盘点: "bg-accent-500/10 text-accent-700",
  市场数据: "bg-secondary-500/15 text-secondary-800",
  官宣情报: "bg-secondary-500/15 text-secondary-800",
  热点观察: "bg-primary-500/10 text-primary-700",
  行业观察: "bg-accent-500/10 text-accent-700",
  行业深挖: "bg-primary-500/10 text-primary-700",
  现场观察: "bg-accent-500/10 text-accent-700",
  文化回潮: "bg-secondary-500/15 text-secondary-800",
  时尚观察: "bg-secondary-500/15 text-secondary-800",
  内容观察: "bg-accent-500/10 text-accent-700",
  文化观察: "bg-accent-500/10 text-accent-700",
  市场分析: "bg-secondary-500/15 text-secondary-800",
  成长故事: "bg-primary-500/10 text-primary-700",
  人物专访: "bg-accent-500/10 text-accent-700",
};

export default function CategoryFeed() {
  const [active, setActive] = useState("影视");
  const current = filterGroups.find((g) => g.name === active) ?? filterGroups[0];

  return (
    <section id="category" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <div>
            <p className="text-xs font-medium uppercase tracking-widest text-accent-600">By Category</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              按栏目翻瓜田
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              影视、综艺、音乐……想吃哪个方向的瓜，点一下就筛选到位。
            </p>
          </div>

          <div
            className="flex flex-wrap items-center gap-2 rounded-2xl border border-background-200 bg-background-50 p-1.5"
            role="tablist"
            aria-label="栏目筛选"
          >
            {categoryTabs.map((cat) => (
              <button
                key={cat}
                type="button"
                role="tab"
                aria-selected={active === cat}
                onClick={() => setActive(cat)}
                className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                  active === cat
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {current.items.map((item) => {
            const color = tagColor[item.tag] || "bg-secondary-500/15 text-secondary-800";
            return (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.img}
                    alt={`${active}栏目：${item.title}`}
                    className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-600">
                    <i className="ri-fire-line" aria-hidden="true"></i> {item.heat.toFixed(1)}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-3 p-5">
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className={`rounded-full px-2.5 py-1 font-medium ${color}`}>{item.tag}</span>
                    <span className="text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="text-base font-bold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
                  <a
                    href="#column"
                    className="mt-auto inline-flex items-center gap-1 pt-1 text-sm font-medium text-primary-600 hover:text-primary-700"
                  >
                    进入详情 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}